import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestFrequencyResponse } from "@/types";

export type CreateFrequencyRequestDTO = {
  name: string;
  days: number;
};

async function createFrequency(
  request: CreateFrequencyRequestDTO
): Promise<RequestFrequencyResponse> {
  const response = await httpRequest.post<RequestFrequencyResponse>(
    "/frequencies",
    request
  );
  return response.data;
}

export function useCreateFrequencyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createFrequency,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["frequencies"] });
    },
  });
}
